import React from 'react'
import './errorContainer.scss'

function ErrorContainer(props) {
    const { title, errorMessage } = props
    return (
        <div className='error-container'>
            <div className='error-heading'>
                {title}
            </div>
            <div className='error-content'>
                {errorMessage}
            </div>
        </div>
    )
}

export default ErrorContainer